// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  isTraceLog: false,
  name: 'prod',
  versionSwitch: false, // true get datas for drops, false get datas for EBX
  url_configurator: 'https://www.oscar-ops.net-courrier.extra.laposte.fr',
  url_api: "https://www.oscar-ops.net-courrier.extra.laposte.fr/api/v1",
  apiU4: 'https://www.oscar-ops.net-courrier.extra.laposte.fr/u4/api/v1',
  apiU5: 'https://www.oscar-ops.net-courrier.extra.laposte.fr/u5/api/v1',
  // This API is used for Devis Contrat calls and tracker tracking
  url_api_uf: 'https://www.oscar-ops.net-courrier.extra.laposte.fr/uf/api/v1',
  url_unb: 'https://www.oscar-ops.net-courrier.extra.laposte.fr/simulator',

  url_banner: 'https://www.oscar-ops.net-courrier.extra.laposte.fr',
  url_cameleon: 'https://www.oscar.net-courrier.extra.laposte.fr/cart/OscarRetourOPS.jsp',
  url_domain: "https://www.oscar.net-courrier.extra.laposte.fr",
  refOpsURI: 'https://www.oscar-ops.net-courrier.extra.laposte.fr/api/v2/mapppro', // RefOps URI
  url_old_oscar_document: 'www.oscar.net-courrier.extra.laposte.fr/cameleonResources/RMGRepository/wksOscar/FILE',
  url_new_oscar_document: 'www.oscar-ops.net-courrier.extra.laposte.fr/documents',
  url_old_oscar_logo: 'www.oscar.net-courrier.extra.laposte.fr/cameleonResources/RMGRepository/wksOscar/IMAGE/logo',
  url_new_oscar_logo: 'www.oscar-ops.net-courrier.extra.laposte.fr/documents/LOGOS_OFFRES',
  xitiEnabled: true,
  xitiSiteId: 594266,
  numVersion: '9',
  cameleonCpName: {
    '268': 'cp0268',
    '279': 'cp0279',
    '269': 'cp0269',
    '199': 'cp0199',
    '17': 'cp0017',
    '95': 'cp0095',
    '276': 'cp0276',
    '204': 'cp0204',
    '42': 'cp0042',
    '76': 'cp0076',
    '40': 'cp0040',
    '256': 'cp0256',
    '237': 'CP_FlashMailing',
    '60': 'cp0060',
    '41': 'cp0041',
    '206': 'CP_cohesio',
    '57': 'cpCOREM',
    '64': 'cpCOREM',
    '59': 'cpCOREM',
    '314': 'cp0314',
    '277': 'cp0277',
    '239': 'cp0239',
    '38': 'cp0038',
    '10': 'cp0010',
    '32': 'cp0032',
    '34': 'cpPackCI',
    '27': 'cpPackCI',
    '35': 'cp0035',
    '23': 'CPAffranchigo',
    '24': 'CPAffranchigo',
    '39': 'cp0039',
    '244': 'cpPackCREN',
    '246': 'cpPackCREN',
    '252': 'cpPackCREN',
    '198': 'cp0198',
    '248': 'cp0248',
    '58': 'cp0058',
    '321': 'cp0321',
    '275': 'cp0275',
    '257': 'cp0257',
    '267': 'cp0267',
    '75': 'cp0075',
    '272': 'cp0272',
    '226': 'cp0226',
    '281': 'cpProxiCourse',
    '282': 'cpProxiCourse',
    '350': 'cpProxiCourse',
    '4': 'cp0004',
    '287': 'cp0287',
    '332': 'cp0332',
    '7': 'cp0007',
    '261': 'CP_PortPaye',
    '247': 'cp0247',
    '6': 'cp0006',
    '341': 'cp0341',
    '286': 'cp0286',
    '352': 'cpPackCI',
    '351': 'cpPackCI',
    '373': 'cp0035',
    '250': 'cp0041',
    '249': 'cp0041',
    '289': 'cp_BoxBienvenue',
    '307': 'cp_BoxBienvenue',
    '242': 'cpPostrep',
    '221': 'cp0058',
    '218': 'CP_WebKey'
  },

  // @since REFOPS-3839
  i2a_get_user_url: 'https://www.oscar-ops.net-courrier.extra.laposte.fr/currentuser'
};
